// extracted by mini-css-extract-plugin
module.exports = {"textInput":"StaffConfig-textInput-6c4201a367352e22676d5a737951900f"};